import {
  defaultSaleStatus,
  defineSaleProgress,
  hasAddress,
  isSaleCreated,
  type ProgressSaleData,
} from '../saleProgress'

export const isInteractionCreated = (data: ProgressSaleData) =>
  !!data.zohoContractDetailId || (isSaleCreated(data) && !data.syncPartnerError && !data.errorPartnerSync)

export default defineSaleProgress({
  kind: 'sale',
  steps: [
    { key: 'address', label: 'additionalSales:pulse.timeline.address', done: hasAddress },
    { key: 'created', label: 'additionalSales:leadInteractionWater.progress.done', done: isInteractionCreated },
  ],
  status: (data, steps) => {
    const status = defaultSaleStatus(data, steps)

    return status === 'wait' ? 'progress' : status
  },
  doneLabel: 'additionalSales:leadInteractionWater.progress.done',
})
